/**
 * @brief index 페이지
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

import React from "react";
import styles from "./Home.module.scss";
import { useNavigate } from "react-router-dom";
import VisitReservation from "../../components/pagesComponents/common/VisitReservation";
import CommonButton from "../../components/common/buttons/CommonButton/CommonButton";
import DoorLockSvg from "./../../assets/images/DoorLock.svg";
import VentilatorSvg from "./../../assets/images/Ventilator.svg";
import CoffeeSvg from "./../../assets/images/Coffee.svg";
import MailboxSvg from "./../../assets/images/Mailbox.svg";
import PrinterSvg from "./../../assets/images/Printer.svg";
import WiFiSvg from "./../../assets/images/WiFi.svg";
import PhoneBoothSvg from "./../../assets/images/PhoneBooth.svg";
import MassageChairSvg from "./../../assets/images/MassageChair.svg";
import MapSvg from "./../../assets/images/Map.svg";
import MakeupSvg from "./../../assets/images/Makeup.svg";
import LockerSvg from "./../../assets/images/Locker.svg";
import ParkingSvg from "./../../assets/images/Parking.svg";
import MetaTags from "../../components/meta/MetaTag";

// 소개 텍스트
const INTRO_ARRAY = [
  {
    title: "최적의 위치",
    content: "SmartWork는 센텀시티의 중심인 KNN 건물에 위치해 있습니다.",
  },
  {
    title: "최고의 인프라",
    content:
      "인근에는 신세계와 롯데백화점, 벡스코, 영화의 전당 등이 있어 다양한 문화적 인프라를 누릴 수 있습니다.",
  },
  {
    title: "편리한 교통",
    content:
      "교통의 중심인 센텀시티에 위치해 있는 만큼 지하철 및 다양한 버스 노선을 이용하여 출퇴근이 가능합니다.",
  },
  {
    title: "다양한 공간",
    content:
      "1인실부터 8인실의 다양한 크기의 사무실은 물론, 인원별 회의실 및 라운지가 마련되어 있어 쾌적한 환경에서 업무를 진행할 수 있습니다.",
  },
];

// 각종 업무지원서비스 텍스트
const SERVICE_ARRAY = [
  {
    Svg: DoorLockSvg,
    title: "개별 호실 디지털 도어록 무료 제공",
  },
  {
    Svg: CoffeeSvg,
    title: "커피 무료 제공",
  },
  {
    Svg: VentilatorSvg,
    title: "개별 냉난방 및 환기 시설",
  },
  {
    Svg: MailboxSvg,
    title: "우편물, 등기, 택배 보관",
  },
  {
    Svg: PrinterSvg,
    title: "복합기 및 사무기기 사용 가능",
  },
  {
    Svg: WiFiSvg,
    title: "유무선 인터넷 무료제공",
  },
  {
    Svg: PhoneBoothSvg,
    title: "프라이빗 통화가 가능한 폰 부스",
  },
  {
    Svg: MassageChairSvg,
    title: "안마 의자 구비 및 사용 가능",
  },
  {
    Svg: MapSvg,
    title: "사업자 주소 제공",
  },
  {
    Svg: MakeupSvg,
    title: "파우더룸 공간 제공",
  },
  {
    Svg: LockerSvg,
    title: "개별적으로 사용 가능한 사물함 제공",
  },
  {
    Svg: ParkingSvg,
    title: "주차 가능한 자리 제공",
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaTags title="공유오피스 스마트워크" />
      <div className={styles.container}>
        {/* 메인 */}
        <section className={styles.banner}>
          <picture className={styles.banner__imgBox}>
            {/* <source
            media="(min-width:960px)"
            srcSet="/assets/images/index_banner.webp"
            type="image/webp"
          /> */}
            <source
              media="(min-width:601px)"
              srcSet="/assets/images/index_banner_07.png"
              type="image/webp"
            />
            <source
              media="(min-width:320px)"
              srcSet="/assets/images/index_banner_07.png"
              type="image/webp"
            />
            <img
              className={styles.banner__img}
              src="/assets/images/index_banner_07.png"
            />
          </picture>
          <div className={styles.banner__btn}>
            <CommonButton
              style={{ borderRadius: "100px" }}
              theme="banner"
              color="black"
              onClick={() => {
                navigate("/contact");
              }}
            >
              방문 신청
            </CommonButton>
          </div>
        </section>
        {/* 메인 끝 */}
        {/* 소개 */}
        <section className={styles.section}>
          <div className={styles.section__inner}>
            <div className={styles.intro}>
              <div className={styles.intro__left}>
                <picture className={styles.banner__imgBox}>
                  <source
                    srcSet="/assets/images/index_knn.webp"
                    type="image/webp"
                  />
                  <img
                    src="/assets/images/index_knn.jpg"
                    alt="intro_img"
                    width={"100%"}
                    height={"100%"}
                  />
                </picture>
              </div>
              <div className={styles.intro__right}>
                <div>
                  {INTRO_ARRAY.map((item) => {
                    return (
                      <section
                        key={item.title}
                        className={styles.intro__infoTxt}
                      >
                        <span className={styles.intro__infoTxt_title}>
                          {item.title}
                        </span>
                        <p className={styles.intro__infoTxt_content}>
                          {item.content}
                        </p>
                      </section>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* 소개 끝 */}
        {/* 각종 업무지원서비스 제공 */}
        <section className={styles.section}>
          <div className={styles.section__inner}>
            <h1>각종 업무지원서비스 제공</h1>
            <div className={styles.service}>
              {SERVICE_ARRAY.map((item) => {
                return (
                  <div key={item.title} className={styles.service__iconbox}>
                    <item.Svg
                      className={styles.service__icon}
                      width="64"
                      height="64"
                      fill="#282d32"
                    />
                    <span className={styles.service__title}>{item.title}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        {/* 각종 업무지원서비스 제공 끝 */}
        {/* 방문 예약 */}
        <section className={styles.section}>
          <div className={styles.section__inner}>
            <h1>방문 예약</h1>
            <VisitReservation />
          </div>
        </section>
        {/* 방문 예약 끝 */}
        {/* 찾아오시는 길 */}
        <section className={styles.section}>
          <div className={styles.section__inner}>
            <h1 className={styles.header}>찾아오시는 길</h1>
            <span className={styles.section__subTitle}>
              부산 해운대구 센텀서로 30 케이엔엔타워 26층
            </span>
            <div className={styles.visit}>
              <div className={styles.visit__imgbox}>
                {/* <source
                type="image/webp"
                srcset="./assets/images/naver_map.webp"
              /> */}
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3261.394786160393!2d129.12602807621417!3d35.171711657794326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x356893113cc3edf3%3A0xd0963754d7bcabf2!2z7Iqk66eI7Yq47JuM7YGs!5e0!3m2!1sko!2skr!4v1737508566323!5m2!1sko!2skr"
                  style={{
                    border: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  loading="lazy"
                  title="SmartWork 위치 지도"
                />
              </div>
            </div>
          </div>
        </section>
        {/* 찾아오시는 길 끝 */}
      </div>
    </>
  );
};

export default Home;
